import React from "react";
import KpiCard from "../../../../../../../components/kpiCard";

const Component = ({ data, addFilter, currentFilters }) => {
  const { id, color, total, kpi, icon, label } = data;
  return (
    <KpiCard
      statusDef={{
        color,
        id,
        status: "active",
        text: label,
      }}
      icon={icon}
      value={{
        count: kpi,
      }}
      total={total}
      onClick={() => {
        addFilter({ key: "type", value: id });
      }}
      selected={currentFilters.type.includes(id)}
    />
  );
};

export default Component;
